/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react';

import { GoogleLogin } from 'Auth/providers/Google';
// import { LegacySignInForm } from 'Auth/providers/Legacy';
import { MSLogin } from 'Auth/providers/MS';
import clsx from 'clsx';
import { useLogo } from 'components/hooks/useLogo';

import { Grid, makeStyles, Paper, View, Stack } from '@gogame/components';
import { useProcessAsync } from '@gogame/hooks-ts';

import { LEGACY_AUTH_TYPE, GOOGLE_AUTH_TYPE, MS_AUTH_TYPE } from '../constants';
import { ErrorMessage } from './components';

const SPACING = 3;
const MIN_HEIGHT = 312;

const useStyles = makeStyles((theme) => ({
  root: {
    width: 640,
    minHeight: MIN_HEIGHT,
    margin: 'auto',
    // backgroundDefault:/* theme.palette.background.default,
    // backgroundPaper: t*/heme.palette.background.paper,
    // padding: theme.spacing(SPACING),
  },
  primaryColor: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  fullHeight: {
    minHeight: MIN_HEIGHT,
  },
  logo: {
    width: 200,
  },
  item: {
    top: '50%',
    transform: 'translate(0, -50%)',
    position: 'relative',
    padding: theme.spacing(SPACING),
  },
}));

const LoginForm = ({ onLogin }) => {
  const classes = useStyles();

  /* eslint-disable-next-line */
  const [loading, processAsync] = useProcessAsync();
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (values) => {
    try {
      await processAsync(onLogin(values, LEGACY_AUTH_TYPE));
    } catch (e) {
      setErrorMessage(e.messages?.[0]);
    }
  };

  const { authLogoUrl } = useLogo();

  return (
    <Paper className={classes.root} elevation={3}>
      <Grid
        data-cy={'loginForm'}
        container
        direction={'row'}
        className={clsx(classes.fullHeight, classes.gridContainer)}
      >
        <Grid
          item
          xs={6}
          className={classes.primaryColor}
          container
          alignContent={'center'}
          justifyContent={'center'}
        >
          <svg className={classes.logo}>
            <use href={authLogoUrl + '#logo'}></use>
          </svg>
        </Grid>
        <Grid item xs={6}>
          <View loading={loading}>
            <div className={classes.item}>
              <Stack spacing={3}>
                {/*<LegacySignInForm onSubmit={handleSubmit} />*/}

                {/*{!isPrivate ? (*/}
                {/*<React.Fragment>*/}
                {/*  <div style={{ position: 'relative' }}>*/}
                {/*    <div*/}
                {/*      style={{*/}
                {/*        position: 'absolute',*/}
                {/*        top: '50%',*/}
                {/*        left: '50%',*/}
                {/*        transform: ' translate(-50%, -50%)',*/}
                {/*        background: '#fff',*/}
                {/*        padding: '2px 8px',*/}
                {/*      }}*/}
                {/*    >*/}
                {/*      <Typography color={'textSecondary'} variant={'caption'}>*/}
                {/*        OR*/}
                {/*      </Typography>*/}
                {/*    </div>*/}
                {/*    <Divider />*/}
                {/*  </div>*/}
                <GoogleLogin />
                <MSLogin onClick={(e) => onLogin(e, MS_AUTH_TYPE)} />
                {/*</React.Fragment>*/}
                {/*) : null}*/}
                <ErrorMessage>{errorMessage}</ErrorMessage>
              </Stack>
            </div>
          </View>
        </Grid>
      </Grid>
    </Paper>
  );
};

export const MultiProviderWidget = ({ onLogin, hasError }) => {
  return <LoginForm onLogin={onLogin} hasError={hasError} />;
};
/* eslint-enable */
